import { APCOA_EI_TENANT_IDS } from '@debbie/common/dist/bespoke/apcoa/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { Site } from '@debbie/common/dist/index.js';
import { MAX_FEE_IMAGE_CACHE_ENTRIES, prefetchFeeImages, } from '@debbie/cortex/dist/bespoke/apcoa/fee-images.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { prefetchCaseData, useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useProcedures } from '@debbie/cortex/dist/procedures/index.js';
import { joinCaseWatchRoom, leaveCaseWatchRoom, } from '@debbie/cortex/dist/socket.js';
import { useWorkflows } from '@debbie/cortex/dist/workflows/index.js';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
const CaseLoader = (props) => {
    const { caseId, nextCaseId } = props;
    prefetchCaseData(props.caseId);
    const site = useSelector((s) => s.site);
    const isCaseworker = site === Site.Caseworker;
    const singleCaseLoader = useCase(caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const tenantId = singleCase?.tenantId;
    // The vouchers are only needed to prefetch the APCOA fee images, so they are
    // not loaded for the tenants that have no fee images
    const prefetchesFeeImages = isCaseworker && tenantId != null && APCOA_EI_TENANT_IDS.includes(tenantId);
    const caseVouchersLoadable = useCaseVouchersByCase(prefetchesFeeImages ? caseId : undefined);
    const caseVouchers = h.hasData(caseVouchersLoadable)
        ? caseVouchersLoadable.data
        : null;
    useCase(nextCaseId);
    useCreditor(singleCase?.creditorId);
    useProcedures({ enabled: isCaseworker });
    useWorkflows({ enabled: isCaseworker });
    useEffect(() => {
        if (!prefetchesFeeImages || tenantId == null || caseVouchers == null) {
            return;
        }
        const feeIds = new Set(caseVouchers
            .filter((caseVoucher) => caseVoucher.category === VoucherCategory.PRINCIPAL &&
            caseVoucher.referenceId)
            .map((caseVoucher) => caseVoucher.referenceId));
        for (const feeId of [...feeIds].slice(0, MAX_FEE_IMAGE_CACHE_ENTRIES)) {
            prefetchFeeImages(feeId, tenantId);
        }
    }, [prefetchesFeeImages, tenantId, caseVouchers]);
    // WS
    useEffect(() => {
        if (singleCase?.id) {
            const _id = `${singleCase?.id}`;
            const timestamp = Date.now();
            joinCaseWatchRoom(_id, timestamp);
            if (props.onLoadTimestamp) {
                props.onLoadTimestamp(timestamp);
            }
            return () => leaveCaseWatchRoom(_id);
        }
    }, [singleCase?.id]);
    return null;
};
export default CaseLoader;
//# sourceMappingURL=CaseLoader.js.map